<template>
    <div @click="redirect" class="grow pointer mt3 bg-white custom-shadow">
        <div style="padding-top:100%" class="relative imageStyle" :style="{ backgroundImage: 'url(' + listing.img + ')' }">
            
        </div>
        <div class="flex justify-between items-center grad white pv3 ph3">
            <h6 style="font-weight: 800;">${{listing.dailyRate}} / Day</h6>
            <div class="bodyCopy">{{listing.distance}} KM</div>
        </div>
        <div style="padding-top:20px; padding-bottom:20px;" class="flex justify-between items-center ph3">
            <h6 style="font-weight:800;">{{listing.title}}</h6>
            <img class="ml2" style="height: 24px; width: 24px;" src="@/assets/img/icon_forward_simple_yellow.svg"/>
        </div> 
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String
        },
        title: {
            type: String
        },
        listing: {
            type: Object
        }
    },
    methods: {
        redirect() {
            this.$router.push({ path: '/listing-detail/' + this.listing.id });
        }
    }
};
</script>

<style>
.imageStyle {
    height: 100%;
    background-position: center;
    background-size: cover;
}

.grad {
    background-image: linear-gradient(#dde2e6, black);
}
</style>
